module.exports = __webpack_public_path__ + "img/tablet-pizzaria.3cb7bd77.webp";